var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked 1",
    clipPath: "url(#clip0_272_834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9985 23.9999C18.626 23.9999 23.9985 18.6273 23.9985 11.9999C23.9985 5.37246 18.626 -0.00012207 11.9985 -0.00012207C5.37112 -0.00012207 -0.00146484 5.37246 -0.00146484 11.9999C-0.00146484 18.6273 5.37112 23.9999 11.9985 23.9999Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.93213 17.4132L15.1025 23.5835C20.2129 22.2208 23.9984 17.5646 23.9984 12C23.9984 11.8864 23.9984 11.7728 23.9984 11.6593L19.1529 7.19238L8.93213 17.4132Z",
    fill: "#21A13A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.2999 14.6875C12.8298 15.2175 12.8298 16.126 12.2999 16.6559L11.2021 17.7537C10.6721 18.2837 9.76358 18.2837 9.23361 17.7537L4.42604 12.9083C3.89607 12.3783 3.89607 11.4698 4.42604 10.9398L5.52383 9.84206C6.0538 9.31209 6.96232 9.31209 7.49229 9.84206L12.2999 14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5017 6.32155C17.0316 5.79158 17.9402 5.79158 18.4701 6.32155L19.5679 7.41934C20.0979 7.94931 20.0979 8.85783 19.5679 9.38779L11.2398 17.678C10.7099 18.208 9.80136 18.208 9.27139 17.678L8.1736 16.5802C7.64363 16.0503 7.64363 15.1417 8.1736 14.6118L16.5017 6.32155Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked_1.39f24246c1f1cb480761c25d319a7b77.svg";
export { ForwardRef as ReactComponent };